import { useContext } from 'react';
import { useMutation } from '@tanstack/react-query';
import { useAPI } from '../lib/hooks';
import { AppContext } from '../sporttia/AppContext';
import type {
    GetActivityRelocations200,
    GetActivityRelocationsParams,
    ResendActivityRelocations200,
    ResendRelocation,
} from '../types/api/paths/ActivityRelocation';

// The relocation endpoints only exist in v7.
const API_VERSION = 'v7';

/**
 * Hook to access the relocations of a copy duplicated with automatic student
 * relocation (CU-869ezdgnr).
 */
export default function useActivityRelocationsService() {
    const { migrationApis } = useContext(AppContext)!;
    const [request] = useAPI(migrationApis);

    /** GET /activities/:id/relocations */
    function getActivityRelocations(
        activityId: number,
        params: GetActivityRelocationsParams,
    ) {
        return request<GetActivityRelocations200>(
            'GET',
            `/activities/${activityId}/relocations`,
            params,
            API_VERSION,
        );
    }

    /** POST /activities/:id/relocations/resend */
    function useResendActivityRelocations(activityId: number) {
        return useMutation({
            mutationFn: (relocations: ResendRelocation[]) =>
                request<ResendActivityRelocations200>(
                    'POST',
                    `/activities/${activityId}/relocations/resend`,
                    { relocations },
                    API_VERSION,
                ),
        });
    }

    return { getActivityRelocations, useResendActivityRelocations };
}
